// ============================================
// Slider.js
// Splide を使ったスライダー初期化モジュール
//
// 使用ライブラリ:
//   Splide : https://splidejs.com/
//
// 機能:
//   - DATA_SOURCES に定義したセレクターとオプションで複数スライダーを管理
//   - レスポンシブ対応（breakpoints オプション）
//   - オートプレイ・ページネーション・矢印ボタン等を設定で制御
//
// ============================================
// HTML 構造例:
// ============================================
//
// <!-- 基本的なスライダー -->
// <section class="splide js-slider-home" aria-label="スライダー">
//   <div class="splide__track">
//     <ul class="splide__list">
//       <li class="splide__slide">
//         <img src="/img/slide01.jpg" alt="スライド1">
//       </li>
//       <li class="splide__slide">
//         <img src="/img/slide02.jpg" alt="スライド2">
//       </li>
//       <li class="splide__slide">
//         <img src="/img/slide03.jpg" alt="スライド3">
//       </li>
//     </ul>
//   </div>
// </section>
//
// <!-- カード型スライダー（3列表示）-->
// <section class="splide js-slider-card" aria-label="カードスライダー">
//   <div class="splide__track">
//     <ul class="splide__list">
//       <li class="splide__slide">カード1</li>
//       <li class="splide__slide">カード2</li>
//       <li class="splide__slide">カード3</li>
//     </ul>
//   </div>
// </section>
// ============================================

import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

import { bindOnce } from '../utils/bindOnce';

// ============================================
// スライダー定義
//
// 新しいスライダーを追加するときは DATA_SOURCES に追記するだけでよい。
// selector   : スライダー要素を指定する CSS セレクター
// options    : Splide のオプション（https://splidejs.com/guides/options/）
// ============================================
const DATA_SOURCES = [
  {
    // ホームのニューススライダー
    // selector: '.splide.p-home-news',
    // options: {
    //   type: 'loop',          // ループ再生（loop / slide / fade）
    //   autoplay: true,        // 自動再生
    //   interval: 4000,        // 自動再生の間隔（ms）
    //   speed: 1000,           // スライド切り替えのアニメーション速度（ms）
    //   perPage: 1,            // 表示するスライド数
    //   perMove: 1,            // 1回の操作で移動するスライド数
    //   pauseOnHover: false,   // ホバーで自動再生を止めない
    //   pauseOnFocus: false,   // フォーカス時に自動再生を止めない
    //   mediaQuery: 'max',     // breakpoints の基準を max-width にする
    //   breakpoints: {
    //     1024: {
    //       perPage: 1,        // 1024px 以下でも 1 枚表示（変更不要なら省略可）
    //     },
    //   },
    // },
  },

  // ============================================
  // スライダー追加例
  // ============================================
  {
    selector: '.splide.js-slider-card',
    options: {
      type: 'loop',
      autoplay: true,
      perPage: 3.8,
      perMove: 1,
      focus: 0,
      gap: '-1px',
      slidesPerView: 3,
      arrows: false,        // 矢印ボタン表示
      pagination: true,    // ドットページネーション表示
      mediaQuery: 'max',
      breakpoints: {
        768: {
          perPage: 1.18,
          gap: '10px',
        },
        1240: {
          perPage: 2.8,
        },
      },
    },
  },
];

// ============================================
// slider — DATA_SOURCES の定義に基づいてスライダーを初期化する
// ============================================
function slider() {
  DATA_SOURCES.forEach(({ selector, options }) => {
    // 同じセレクターの要素が複数あってもすべて初期化する
    const targets = document.querySelectorAll(selector);

    targets.forEach((target) => {
      // 二重マウント防止（DOMContentLoaded 後の再実行に備える）
      if (!bindOnce(target, 'splideMount')) return;

      new Splide(target, options).mount();
    });
  });
}

export { slider };
